module.exports = __webpack_public_path__ + "fa2ee2f8.svg";